import { useState } from "react";
import { useBjelinTranslations } from "../../hooks/TranslationHooks";
import { useLink } from "valuelink";
import { Alert, Button, FormGroup, Input, Label } from "reactstrap";
import BjelinButton from "../BjelinButton";
import apiService from "../../services/apiService";
import EmailValidator from "email-validator";
import ErrorCodes from "../../config/ErrorCodes";
import Icon from "../Icon";

const ForgotPasswordForm = ({ close }) => {
  const t = useBjelinTranslations();
  const email = useLink("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [sent, setSent] = useState(false);

  const sendResetEmail = () => {
    const validEmail = EmailValidator.validate(email.value);
    if (!loading) {
      if (validEmail) {
        setLoading(true);
        apiService
          .sendForgotPasswordEmail(email.value)
          .then(() => {
            setSent(true);
            setLoading(false);
          })
          .catch(error => {
            console.error("sendForgotPasswordEmail error", error.response.data);
            setError(t("unknown.error"));
            setLoading(false);
          });
      } else {
        setError(t(ErrorCodes.EMAIL_INVALID));
      }
    }
  };

  return !sent ? (
    <>
      <Button close onClick={close}>
        <Icon name="xmark" type="fal" />
      </Button>
      <h2>{t("forgot.your.password")}</h2>
      <p className="pre-wrap">{t("forgot.password.descr")}</p>
      <FormGroup>
        <Label>
          {t("email.address")}
          <Input
            type={"text"}
            {...email.props}
            placeholder={t("email.address")}
          />
        </Label>
      </FormGroup>
      {error && (
        <FormGroup>
          <Alert color={"danger"}>{error}</Alert>
        </FormGroup>
      )}
      <BjelinButton
        loading={loading}
        color={"bjelin-green"}
        className={"me-2"}
        onClick={sendResetEmail}
        icon={"arrow-right"}
      >
        {t("proceed")}
      </BjelinButton>
    </>
  ) : (
    <>
      <h1>{t("reset.password")}</h1>
      <Alert color="success" className={"mt-4"}>
        {t("reset.email.sent")}
      </Alert>
      <BjelinButton color={"bjelin-green"} onClick={close}>
        {t("ok")}
      </BjelinButton>
    </>
  );
};

export default ForgotPasswordForm;
